
const ContentToggle = {

	init: function () {
		const visibleClass = 'content-toggle-visible';
		const controls = document.querySelectorAll('[data-content-toggle]');
		const targets = document.querySelectorAll('[data-content-toggle-target]');

		controls.forEach(control => {
			control.addEventListener('click', event => {
				controls.forEach(c => c.classList.remove(visibleClass));
				control.classList.add(visibleClass);
				targets.forEach(target => {
					console.log(target.dataset.contentToggleTarget, control.dataset.contentToggle);
					if (target.dataset.contentToggleTarget === control.dataset.contentToggle) {
						target.classList.add(visibleClass);
					} else {
						target.classList.remove(visibleClass);
					}
				});

				control.scrollIntoView({
					behavior: 'smooth',
				});
			});
		});
	}
}

export default ContentToggle;
